import { getTimezone } from '@heidi/utils/get-country';
import { TZDate } from '@date-fns/tz';

const DATE_ONLY_REGEX = /^(\d{4})-(\d{2})-(\d{2})$/u;

/**
 * Parse a `YYYY-MM-DD` value into a `Date` anchored in the user's timezone.
 *
 * Stays here (rather than in `@heidi/utils` with its pure sibling
 * `parseSessionDateRange`) because it reads the user's timezone from the app's
 * country helper — an app-coupled input a neutral util may not carry.
 */
export const parseSessionCalendarDate = (
  value: string | undefined
): Date | undefined => {
  const match = value?.match(DATE_ONLY_REGEX);
  if (!match?.[1] || !match[2] || !match[3]) return undefined;

  const year = Number(match[1]);
  const monthIndex = Number(match[2]) - 1;
  const day = Number(match[3]);
  const date = new TZDate(year, monthIndex, day, getTimezone());

  if (
    date.getFullYear() !== year ||
    date.getMonth() !== monthIndex ||
    date.getDate() !== day
  ) {
    return undefined;
  }

  return date;
};
